import React from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../../CustomButton";
import SoundPlayButton from "./SoundPlayButton";

export default function SoundSelector (props) {
    const { soundKeyName, name, subType, value, setSoundTypes, customSoundsOptions = [], selectHandler } = props;
    const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType' });

    const defaultSoundsOptions = [
        {
            value: "0",
            label: t('disableAudio')
        },
        {
            value: "2",
            label: t('eventChime')
        },
        {
            value: "1",
            label: t('eventVoicePrompt')
        },
        {
            value: "3",
            label: t('both')
        },
    ];

    const soundsOptions = customSoundsOptions.length ? customSoundsOptions : defaultSoundsOptions;

    const setNewValue = (value) => () => {
        if (selectHandler) {
            selectHandler(value);
        } else {
            setSoundTypes(name, value, subType);
        }
    }

    return (
        <div className="button-group">
            {
                soundsOptions.map((option, index) => (
                    <CustomButton
                        disabled={+option.value === 3} // Temporary disabled Both option until the firmware is ready
                        key={`sound_toggle_${option.value}`}
                        variant="toggle-group"
                        active={value === +option.value}
                        onClick={setNewValue(option.value)}
                    >
                        {option.label}
                    </CustomButton>
                ))
            }
            <SoundPlayButton soundKeyName={soundKeyName} name={name} value={value} />
        </div>
    )
}
